var map = {
	"./corporate-social-responsibility-1.png": "58c0",
	"./corporate-social-responsibility.png": "ca85",
	"./management-philosophy-1.png": "6681",
	"./management-philosophy-2.png": "e710",
	"./management-philosophy-3.png": "efd0",
	"./management-philosophy.png": "2f6b",
	"./story.png": "be2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b588";